import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const TipoDocumentoRepositorioJuridicoService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Documento_Repositorio_Juridico_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			tipo_documento: form.tipo_documento,
			abreviacion: form.abreviacion,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Documento_Repositorio_Juridico_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_tipo_documento_repositorio_juridico: form.id_cat_tipo_documento_repositorio_juridico,
			tipo_documento: form.tipo_documento,
			abreviacion: form.abreviacion,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Documento_Repositorio_Juridico_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_tipo_documento_repositorio_juridico) => {
		let params = {
			id_cat_tipo_documento_repositorio_juridico: id_cat_tipo_documento_repositorio_juridico
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Documento_Repositorio_Juridico_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
